import React from "react";
import DiscountIcon from "@/public/fallbacks/discount-transparent.svg";

const DiscountTagBlock = ({ discountAppliedLabel }) => {
  return (
    <p className="productCard__titleBlock__discountTagBlock">
      <img className="productCard__titleBlock__discountTag" src={DiscountIcon} alt="Discount" />
      {discountAppliedLabel}
    </p>
  );
};

export default DiscountTagBlock;
